import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Asian%20luxury%20aesthetic%20with%20silk%20textures%20and%20golden%20accents%20on%20warm%20cream%20background%2C%20minimalist%20composition%20with%20tea%20ceremony%20elements%2C%20soft%20atmospheric%20lighting%2C%20artistic%20abstract%20style%20with%20Japanese%20and%20Chinese%20cultural%20motifs&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="亚洲精品 - 甄选亚洲顶级品质产品与品牌"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/15 to-black/25" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 md:mb-6 leading-tight">
          <strong>亚洲精品</strong>
          <br />
          <span className="text-2xl md:text-3xl lg:text-4xl font-normal opacity-90">
            甄选亚洲顶级品质产品与品牌
          </span>
        </h1>
        <p className="text-sm md:text-base lg:text-lg text-white/80 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          汇聚亚洲各国顶级品质商品，涵盖时尚、美妆、食品、工艺等多品类精选好物。我们严格把关每一件亚洲精品，为您带来真正代表亚洲工艺与品味的优质产品。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/fashion"
            className="px-6 py-3 text-sm md:text-base font-medium rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 no-underline whitespace-nowrap cursor-pointer"
          >
            探索亚洲精品
          </Link>
          <Link
            to="/articles"
            className="px-6 py-3 text-sm md:text-base font-medium rounded-md bg-white/15 text-white hover:bg-white/25 backdrop-blur-sm transition-all duration-200 no-underline whitespace-nowrap cursor-pointer border border-white/20"
          >
            阅读精选文章
          </Link>
        </div>
      </div>
    </section>
  );
}